module.exports = __webpack_public_path__ + "static/media/404.9ed13bbe.svg";